import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { Box, CircularProgress, Table, TableBody, TableContainer, Typography } from '@mui/material';
import { Styles, ADGroupStyledTableCell, StyledTableRow } from 'pages/myidm/style';
import Accordian from './Accordian';

const AccordianList = (props) => {
    const { title, isExpanded, onToggle, endPoint, order } = props;
    const [hasFetched, setHasFetched] = useState(false);
    const [data, setData] = useState([]);
    const titleRef = useRef(null);

    const adGroupMembersApi = useMutation((payload) => axios.get(`${endPoint}/${payload}/${order?.domainType}`));

    React.useEffect(() => {
        if (adGroupMembersApi?.isSuccess) {
            setData(adGroupMembersApi?.data?.data ?? []);
            setHasFetched(true);
        }
    }, [adGroupMembersApi?.isSuccess]);

    React.useEffect(() => {
        if (adGroupMembersApi?.isError) {
            setHasFetched(true);
            setData([]);
        }
    }, [adGroupMembersApi?.isError]);

    useEffect(() => {
        if (isExpanded && !hasFetched) {
            const payload = title;
            titleRef.current = title;
            adGroupMembersApi?.mutate(payload);
        }
    }, [isExpanded, hasFetched]);

    useEffect(() => {
        if (isExpanded && title !== titleRef.current) {
            titleRef.current = title;
            setHasFetched(false);
            adGroupMembersApi?.mutate(title);
        }
    }, [title, isExpanded]);
    return (
        <>
            <Accordian title={title} isExpanded={isExpanded} onChange={onToggle}>
                <TableContainer sx={Styles?.AddMemberForm?.table.AdGrptableWrapper}>
                    <Table sx={{ ...Styles?.AddMemberForm?.table?.memListmain, minHeight: '50px', borderSpacing: 0 }} size="small" stickyHeader>
                        <TableBody>
                            {adGroupMembersApi?.isLoading && (
                                <Box sx={Styles?.addMembersCard?.loader}>
                                    <CircularProgress color="inherit" size={16} />
                                    <Typography variant="body2" sx={{ color: '#000000', marginTop: 1 }}>
                                        Loading...
                                    </Typography>
                                </Box>
                            )}
                            {!adGroupMembersApi?.isLoading && hasFetched && data?.length === 0 && <Box sx={Styles?.addMembersCard?.nomembers}>No Members</Box>}
                            {adGroupMembersApi?.isError && !adGroupMembersApi?.isLoading && <Box sx={Styles?.addMembersCard?.wrongMsg}>Something is Wrong</Box>}
                            {!adGroupMembersApi?.isLoading && data?.length > 0 && (
                                <>
                                    {data?.map((member) => (
                                        <StyledTableRow className="animate-opacity" key={member?.gpid}>
                                            <ADGroupStyledTableCell>{member?.gpid || ''}</ADGroupStyledTableCell>
                                            <ADGroupStyledTableCell>{`${member?.firstName} ${member?.lastName}` || '-'}</ADGroupStyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Accordian>
        </>
    );
};

AccordianList.propTypes = {
    title: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    endPoint: PropTypes.string.isRequired,
    order: PropTypes.any.isRequired,
};

export default AccordianList;
